import { search, scrollToProducts } from "algolia-instant-search";

const { rangeSlider } = instantsearch.widgets;
const { connectRange } = instantsearch.connectors;

if (!customElements.get("algolia-price-range")) {
  class AlgoliaPriceRange extends HTMLElement {
    constructor() {
      super();
      const observer = new MutationObserver(this.observerCallback.bind(this));
      observer.observe(this, this.oberserverConfig);
    }

    attribute = this.dataset.attribute;
    heading = this.dataset.heading;
    oberserverConfig = { attributes: false, childList: true, subtree: true };

    connectedCallback() {
      this.selectElements();

      const customPriceRange = connectRange(this.renderPriceRange.bind(this));
      search.addWidgets([
        customPriceRange({
          container: this.rangeInputContainer,
          attribute: this.attribute,
          heading: this.heading,
        }),
      ]);
    }

    selectElements() {
      this.rangeInputTemplate = this.querySelector("template#input");
      this.rangeInputContainer = this.querySelector("#range-input");
    }

    renderPriceRange(renderOptions, isFirstRender) {
      const { start, range, refine, widgetParams } = renderOptions;

      if (isFirstRender) {
        const priceRangeClone = this.rangeInputTemplate.content.cloneNode(true);
        const details = priceRangeClone.querySelector("details");
        details.className = "filter-group filter-group--price";

        const heading = widgetParams.heading || "Price";
        priceRangeClone.querySelector("#heading").textContent = heading;

        widgetParams.container.appendChild(priceRangeClone);
        this.rangeSliderContainer =
          priceRangeClone.querySelector("#range-slider");

        // Get input elements
        const minInput = widgetParams.container.querySelector(".jsRangeMin");
        const maxInput = widgetParams.container.querySelector(".jsRangeMax");

        // Store references
        this.minInput = minInput;
        this.maxInput = maxInput;

        // Add input event listeners
        let inputTimeout;
        const handleInputChange = () => {
          clearTimeout(inputTimeout);
          inputTimeout = setTimeout(() => {
            const minValue = minInput.value
              ? parseFloat(minInput.value)
              : undefined;
            const maxValue = maxInput.value
              ? parseFloat(maxInput.value)
              : undefined;
            refine([minValue, maxValue]);
            scrollToProducts();
          }, 500);
        };

        minInput.addEventListener("input", handleInputChange);
        maxInput.addEventListener("input", handleInputChange);
      }

      if (this.minInput && this.maxInput) {
        this.minInput.value =
          start[0] === -Infinity ? range.min : Math.round(start[0]);
        this.maxInput.value =
          start[1] === Infinity ? range.max : Math.round(start[1]);

        // Set max attributes based on range
        if (range.max !== Infinity) {
          this.minInput.setAttribute("max", Math.round(range.max));
          this.maxInput.setAttribute("max", Math.round(range.max));
        }
      }

      // Update clear button on every render
      const clearBtn = widgetParams.container.querySelector(
        ".jsFilterGroupClear",
      );
      const newClearBtn = clearBtn.cloneNode(true);
      clearBtn.parentNode.replaceChild(newClearBtn, clearBtn);

      newClearBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.minInput.value = "";
        this.maxInput.value = "";
        refine([undefined, undefined]);
        scrollToProducts();
      });

      const hasRefinements = start[0] !== -Infinity || start[1] !== Infinity;
      newClearBtn.classList.toggle("none", !hasRefinements);
    }

    observerCallback(mutationList, observer) {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const sliderContainer =
            mutation.target.querySelector("#range-slider");
          if (sliderContainer) {
            search.addWidgets([
              rangeSlider({
                container: sliderContainer,
                attribute: this.attribute,
                pips: false,
                tooltips: false,
                //FIXME: should be able to override
                cssClasses: {
                  root: "range-slider-el noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr",
                  handle: "noUi-handle",
                  lowerHandle: "noUi-handle noUi-handle-lower",
                  upperHandle: "noUi-handle noUi-handle-lower",
                  tooltip: "noUi-tooltip",
                },
              }),
            ]);
            observer.disconnect(); // This is only used to render slider
          }
        }
      }
    }
  }
  customElements.define("algolia-price-range", AlgoliaPriceRange);
}
